import axios, { isAxiosError } from "axios";
import { _axios } from "../../utils/axios";
import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { SpinnerCircular } from "spinners-react";
import applicationIcon from "../../assets/images/landing/Application.svg";
import completeIcon from "../../assets/images/landing/complete.svg";
import paymentIcon from "../../assets/images/landing/payment.svg";
import registrationIcon from "../../assets/images/landing/registration.svg";
import reviewIcon from "../../assets/images/landing/review.svg";
import submissionIcon from "../../assets/images/landing/submission.svg";
import SidebarItems from "../../components/SidebarItems";
import { ErrorToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import { useApplicationForLandingPage } from "../../hooks/applications.hooks";
import { cookieUtils } from "../../utils/cookieUtils";
import style from "./landing.module.css";
import CP from "../../assets/CivicPlanLogo.png"

interface TickerItem {
  ticker_id: number;
  text_details: string;
  start_date: string;
  end_date: string;
  status: number;
}


const DownloadsDropdown = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative group" ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className={`border-none ${style.login} flex items-center gap-1 cursor-pointer`}
      >
        User Guide <span className="text-xs">▼</span>
      </button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-50">
          <a 
            href="https://gunthewariqa.blob.core.windows.net/bahadura/RL Application Process User Guide.pdf" 
            target="_blank" 
            rel="noreferrer"
            className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 border-b border-gray-100"
            onClick={() => setIsOpen(false)}
          >
            User Guide
          </a>
          <a 
            href="https://gunthewariqa.blob.core.windows.net/bahadura/हमीपत्र व क्षतीपुर्ती बंध AFFIDAVIT.pdf" 
            target="_blank" 
            rel="noreferrer"
            className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
            onClick={() => setIsOpen(false)}
          >
            Hamipatra & Kshatipurti
          </a>
        </div>
      )}
    </div>
  );
};

export function LandingHeader() {
  const navigate = useNavigate();
  const [currentDateTime, setCurrentDateTime] = useState<string>(() => {
    const istOptions: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

    const istDateTime = new Date().toLocaleString("en-IN", istOptions);
    return istDateTime;
  });
  const onLogin = () => {
    navigate("/onboarding/login");
  };

  const [tickerData, setTickerData] = useState<TickerItem[]>([]);
  const [existingLogo, setExistingLogo] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch logo
        const logoResponse = await _axios.get(`${BASE_URL}/api/logo`);
        if (logoResponse.data.success === 1) {
          setLogoUrl(logoResponse.data.url);
          if (logoResponse.data.filename) {
            setExistingLogo(logoResponse.data.filename);
          }
        }
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    fetchTickerData();
  }, []);

  const fetchTickerData = async () => {
    try {
      const currentDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const formattedDate = currentDate.split("/").join("-");
      console.log("Request body: { current_date:", formattedDate, "}");
      const response = await fetch(`${BASE_URL}/api/ticker/status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ current_date: formattedDate }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch ticker data");
      }
      const data = await response.json();
      setTickerData(data.data);
    } catch (error) {
      console.error("Error fetching ticker data:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const istOptions: Intl.DateTimeFormatOptions = {
        timeZone: "Asia/Kolkata",
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      };

      const istDateTime = new Date().toLocaleString("en-IN", istOptions);
      setCurrentDateTime(istDateTime);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div>
      <header className={style.header}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Logo"
            className={style.companyIcon}
          />
        )}
        <div className={style.loginInfo}>
          <div className="hidden sm:flex gap-8 items-center">
            
            
              <DownloadsDropdown />

            <NavLink to={"/"}
              className={({ isActive }) =>
                isActive
                  ? `${style.login} !border-b !border-primary`
                  : `border-none ${style.login}`
              }
            >
              Home
            </NavLink>
            {/* <NavLink
              to={"/about"}
              className={({ isActive }) =>
                isActive
                  ? `${style.login} !border-b !border-primary`
                  : `border-none ${style.login}`
              }
            >
             About Us
            </NavLink> */}
            <NavLink
              to={"/onboarding/login"}
              className={({ isActive }) =>
                isActive
                  ? `${style.login} !border-b !border-primary`
                  : `border-none ${style.login}`
              }
            >
              Login
            </NavLink>
          </div>

          <div className={style.dateTimeWeather}>
            <div className={style.dateWrapper}>
              <div className={style.dayOfWeek}>
                {currentDateTime.split(",")[0]},
              </div>
              <div className={style.dateAndTime}>
                {currentDateTime
                  .split(",")
                  .slice(1)
                  .join(",")
                  .replace(" at", "")}
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="py-2 px-4 justify-around flex sm:hidden gap-4 items-center">
        
            
              <DownloadsDropdown />

            <NavLink to={"/"}
          className={({ isActive }) =>
            isActive
              ? `${style.login} !border-b !border-primary`
              : `border-none ${style.login}`
          }
        >
          Home
        </NavLink>
        {/* <NavLink
          to={"/about"}
          className={({ isActive }) =>
            isActive
              ? `${style.login} !border-b !border-primary`
              : `border-none ${style.login}`
          }
        >
          About Us
        </NavLink> */}
        <NavLink
          to={"/onboarding/login"}
          className={({ isActive }) =>
            isActive
              ? `${style.login} !border-b !border-primary`
              : `border-none ${style.login}`
          }
        >
          Login
        </NavLink>
      </div>
      <Marquee className={style.marqueeLine} gradient={false} speed={70}>
        <div style={{ color: "#fff" }}>
          {tickerData.map((ticker, index) => (
            <span
              key={index}
              className="marqueeColor"
              style={{ marginRight: "20px" }}
            >
              {ticker.text_details}
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}

function SelectRole() {
  const [applicationIdInput, setApplicationIdInput] = useState("");
  const [applicationId, setApplicationId] = useState("");
  const query = useApplicationForLandingPage(applicationId);
  let navigate = useNavigate();
  const [isSelectRole, setIsSelectRole] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [isSubCategory, setIsSubCategory] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const [otpList, setOtpList] = useState<any>(["", "", "", ""]);
  const [phone, setPhone] = useState<string>("");
  const [role, setRole] = useState<string>("Select Role");
  const [subRole, setSubRole] = useState<string>();
  const [loader, setLoader] = useState<boolean>();
  const [bannerList, setBannerList] = useState<Array<any>>([]);
  const [footerText, setFooterText] = useState("");

  const location = useLocation();

  useEffect(() => {
    fetchData();
    handleRouting();
  }, []);

  const handleRouting = () => {
    const userSubRole = cookieUtils.getSecureCookie("subRole");

    if (!userSubRole) {
      // Handle case when no subRole is found
      return;
    }

    let targetRoute;
    switch (userSubRole) {
      case "super":
        targetRoute = findMatchingRouteOrDefault(SidebarItems.AdminItems);
        break;
      case "state":
      case "district":
      case "block":
        targetRoute = findMatchingRouteOrDefault(SidebarItems.StateLevelItems);
        break;
      case "user":
        targetRoute = findMatchingRouteOrDefault(SidebarItems.UserItems);
        break;
      default:
        targetRoute = findMatchingRouteOrDefault(SidebarItems.WorkerItems);
    }

    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  const findMatchingRouteOrDefault = (items: any[]) => {
    const matchingRoute = items.find(
      (item) => item.route === location.pathname
    );
    return matchingRoute ? matchingRoute.route : items[0]?.route;
  };

  const fetchData = () => {
    _axios
      .post(`${BASE_URL}/api/footer/footer`)
      .then((response) => {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        const data = response.data.data[0];
        setFooterText(data.footer_text || "");
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message);
        }
        console.error("Error fetching footer data:", error);
      });
  };

  const onNextButton = () => {
    setIsSelectRole(false);
    setIsSubCategory(true);
  };
  const onCategoryNextButton = () => {
    setIsSubCategory(false);
    setIsLogin(true);
  };

  const sliderSetting = {
    dots: true,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set the autoplay speed to 3000 milliseconds (3 seconds)
  };

  const num1 = React.createRef<HTMLInputElement>();

  const num2 = React.createRef<HTMLInputElement>();

  const num3 = React.createRef<HTMLInputElement>();

  const num4 = React.createRef<HTMLInputElement>();

  const handleOtp1Change = (value: any) => {
    otpList[0] = value;
    num2.current?.focus();
  };
  const handleOtp2Change = (value: any) => {
    otpList[1] = value;
    num3.current?.focus();
  };

  const handleOtp3Change = (value: any) => {
    otpList[2] = value;
    num4.current?.focus();
  };

  const handleOtp4Change = (value: any) => {
    otpList[3] = value;
    //only update the value here
  };

  const checkNavigation = () => {
    setLoader(true);
  };

  const isOtpFilled = () => {
    if (num1.current?.value.length == 0) return false;
    else if (num2.current?.value.length == 0) return false;
    else if (num3.current?.value.length == 0) return false;
    else if (num4.current?.value.length == 0) return false;
    else return true;
  };

  const onLoginNext = () => {
    setLoader(true);
    setIsLogin(false);
    setIsOtp(true);
    setLoader(false);
  };

  //Get Banner
  const getBanner = () => {
    _axios
      .get(`${BASE_URL}/api/banner/status`)
      .then(function (response) {
        console.log("Banner Response", response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setBannerList(response?.data?.data);
      })
      .catch(function (error: any) {
        // handle error
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message);
          console.log("error", error);
        }
      });
  };

  useEffect(() => {
    getBanner();
  }, []);

  let toRender = (
    <div className={style.statusDetails}>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Application Id</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>
          {query?.data?.data?.applicationId || "--"}
        </div>
      </div>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Layout Name</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>
          {query?.data?.data?.unauthorized_layout_name || "--"}
        </div>
      </div>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Mauza</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>{query?.data?.data?.mauja || "--"}</div>
      </div>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Khasara No.</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>
          {query?.data?.data?.khasara_no || "--"}
        </div>
      </div>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Area of the Plot</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>
          {query?.data?.data?.area_of_plot || "--"}
        </div>
      </div>
      <div className={style.detailItem}>
        <div className={style.left}>
          <strong>Application status</strong>
        </div>
        <div className={style.center}>:</div>
        <div className={style.right}>{query?.data?.data?.status || "--"}</div>
      </div>
    </div>
  );

  if (query?.isLoading || query.isError) {
    let message =
      (isAxiosError(query.error) && query.error.response?.data?.message) ||
      "Application not found!";
    toRender = (
      <div className="flex justify-center items-center p-8">
        {query.isError ? <p>{message}</p> : <SpinnerCircular />}
      </div>
    );
  } else if (!applicationId) {
    toRender = <></>;
  }

  return (
    <div>
      <LandingHeader />
      <div className={style.applicationStatus}>
        <main className={style.mainContent}>
          <div className={style.topBorderBox}>
            <div className={style.textPad}>
              <h4 className={style.checkHeading}>Check Application Status</h4>
              <h4 className={style.smallHeading}>Application Id</h4>

              <div className={style.inputButtonWrap}>
                <input
                  type="text"
                  value={applicationIdInput}
                  onChange={(e) => setApplicationIdInput(e.target.value)}
                  className={style.inputCheck}
                />
                <button
                  className={style.checkBtn}
                  disabled={!applicationIdInput}
                  onClick={() => {
                    if (
                      applicationIdInput &&
                      applicationIdInput === applicationId
                    ) {
                      query.refetch();
                    } else setApplicationId(applicationIdInput);
                  }}
                >
                  Check
                </button>
              </div>
              {toRender}
            </div>
          </div>

          <div className={style.topBorderBoxBottom}>
            <Slider {...sliderSetting}>
              {bannerList.length === 0 ? (
                <img
                  src="https://img.freepik.com/free-photo/beautiful-view-construction-site-city-during-sunset_181624-9347.jpg" // Provide the path to your default banner image
                  alt="Default Banner"
                  className={style.imgClass}
                />
              ) : (
                bannerList.map((banner, index) => (
                  <img
                    key={index}
                    src={banner.image_url}
                    alt={`Construction Site ${index + 1}`}
                    className={style.imgClass}
                  />
                ))
              )}
            </Slider>
          </div>
        </main>

        <div className={`bg-secondary ${style.bodyPinkSection}`}>
          <div className={style.bottomBodyPink}>
            <center>
              <h2 className={style.ApplicationHeading}>Application Process</h2>
              <div className={style.yellowLine}></div>
            </center>
            <div className={style.cardContainer}>
              <div className={style.card}>
                <img
                  src={registrationIcon}
                  className={style.circle}
                  alt="Registration Icon"
                />
                <h2 className={style.boxSubTile}>Registration</h2>
                <p className={style.paraCard}>
                  You need to submit the registration
                  <br />
                  form to apply for the building
                  <br />
                  sanctioning process.
                </p>
              </div>
              <div className={style.card}>
                <img
                  src={applicationIcon}
                  className={style.circle}
                  alt="Application Icon"
                />
                <h2 className={style.boxSubTile}>Application</h2>
                <p className={style.paraCard}>
                  After successful registration,
                  <br />
                  you will be able to apply for
                  <br />
                  various sanctioning services.
                </p>
              </div>
              <div className={style.card}>
                <img
                  src={submissionIcon}
                  className={style.circle}
                  alt="Submission Icon"
                />
                <h2 className={style.boxSubTile}>Submission</h2>
                <p className={style.paraCard}>
                  After your successful
                  <br />
                  submission of the application form,
                  <br />
                  you will be able to view and
                  <br />
                  check the status of your application.
                </p>
              </div>
            </div>
            {/* <br />
            <br /> */}
            <div className={style.cardContainer}>
              <div className={style.card}>
                <img
                  src={reviewIcon}
                  className={style.circle}
                  alt="Review Icon"
                />
                <h2 className={style.boxSubTile}>Review</h2>
                <p className={style.paraCard}>
                  Your application will be reviewed
                  <br />
                  by the reviewers. Once the
                  <br />
                  application is reviewed, the
                  <br />
                  reviewers will make the decision.
                </p>
              </div>
              <div className={style.card}>
                <img
                  src={paymentIcon}
                  className={style.circle}
                  alt="Payment Icon"
                />
                <h2 className={style.boxSubTile}>Payment</h2>
                <p className={style.paraCard}>
                  Once the Demand Note for
                  <br />
                  your application is approved,
                  <br />
                  you are eligible to make
                  <br />
                  payment online or offline.
                </p>
              </div>
              <div className={style.card} style={{ marginBottom: "27px" }}>
                <img
                  src={completeIcon}
                  className={style.circle}
                  alt="Complete Icon"
                />
                <h2 className={style.boxSubTile}>Complete</h2>
                <p className={style.paraCard}>
                  Once the overall review is done,
                  <br />
                  you will be able to download
                  <br />
                  the signed map &amp; certificate.
                </p>
              </div>
            </div>
          </div>
        </div>
        <footer className={style.landingpageFooter}>
          {footerText ??
            "Powered by Stralto Global Pvt. Ltd. All rights reserved."}
        </footer>
      </div>
    </div>
  );
}

export default SelectRole;
